module.exports = __webpack_public_path__ + "img/logo.208e3ee6.jpg";